import React, { useEffect, useState, useContext } from 'react';
import HeroSection from '../components/Home/HeroSection';
import AnalysisCardsSection from '../components/Home/AnalysisCardsSection';
import FeaturesSection from '../components/Home/FeaturesSection';
import HowItWorksSection from '../components/Home/HowItWorksSection';
import SemanticBrandingSection from '../components/Home/SemanticBrandingSection';
import LoginModal from '../components/Authentication/LoginModal';
import RegisterModalNoCode from '../components/Authentication/RegisterModalNoCode';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { semanticBrandingService } from '../services/semanticBranding';
import { ToastContext } from '../App';
// Página especial para evento Traktion - SEM código de convite
const ShareDiegoIvoEventos = ({
  isLoggedIn,
  onLogin,
  user
}) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [pendingAnalysis, setPendingAnalysis] = useState(false);
  const [brandData, setBrandData] = useState({
    brand: '',
    url: ''
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    addToast
  } = useContext(ToastContext);
  useEffect(() => {
    // Check if showLogin parameter is present
    if (searchParams.get('showLogin') === 'true' && !isLoggedIn) {
      setIsLoginModalOpen(true);
    }
  }, [searchParams, isLoggedIn]);
  // Check if user is logged in and has a pending analysis
  useEffect(() => {
    if (isLoggedIn && pendingAnalysis && brandData.brand && brandData.url) {
      const createAnalysis = async () => {
        try {
          // Create a new brand document with the pending data
          const response = await semanticBrandingService.createBrandDocument(brandData.brand, brandData.url, true);
          // Navigate to the report page with the document ID and isNewDocument flag
          navigate(`/relatorio/${response.brandDocument.id}`, {
            state: {
              isNewDocument: true
            }
          });
          addToast('success', 'Análise iniciada com sucesso!');
          setPendingAnalysis(false);
        } catch (error) {
          console.error('Failed to create brand document:', error);
          addToast('error', error.response?.data?.message || 'Erro ao criar análise. Tente novamente.');
          setPendingAnalysis(false);
        }
      };
      createAnalysis();
    }
  }, [isLoggedIn, pendingAnalysis, brandData, navigate, addToast]);
  const handleStartAnalysis = (data = null) => {
    if (data) {
      setBrandData(data);
    }
    // If not logged in, store that we have a pending analysis and open register modal (NO CODE version)
    if (!isLoggedIn) {
      setPendingAnalysis(true);
      setIsRegisterModalOpen(true);
    } else {
      // If logged in, create brand document and navigate to report
      const createAnalysis = async () => {
        try {
          const response = await semanticBrandingService.createBrandDocument(data.brand, data.url, true);
          navigate(`/relatorio/${response.brandDocument.id}`, {
            state: {
              isNewDocument: true
            }
          });
          addToast('success', 'Análise iniciada com sucesso!');
        } catch (error) {
          console.error('Failed to create brand document:', error);
          addToast('error', error.response?.data?.message || 'Erro ao criar análise. Tente novamente.');
        }
      };
      createAnalysis();
    }
  };
  // Handler para abrir o modal de registro (sem código)
  const handleOpenRegister = () => {
    setIsLoginModalOpen(false);
    setIsRegisterModalOpen(true);
  };
  // Handler para abrir o modal de login
  const handleOpenLogin = () => {
    setIsRegisterModalOpen(false);
    setIsLoginModalOpen(true);
  };
  return <>
      <HeroSection isLoggedIn={isLoggedIn} onStartAnalysis={handleStartAnalysis} data-id="element-1371" data-mp="mnka5bmdbhuj" />
      <AnalysisCardsSection isLoggedIn={isLoggedIn} data-id="element-1372" data-mp="rllvk379nt96" />
      <FeaturesSection data-id="element-1373" data-mp="wjn9k9pu52ds" />
      <HowItWorksSection data-id="element-1374" data-mp="wjdjkm4siv83" />
      <SemanticBrandingSection data-id="element-1375" data-mp="wiu9tspand55" />

      {/* Modal de Login */}
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} onRegisterClick={handleOpenRegister} pendingAnalysis={pendingAnalysis} data-id="element-1376" data-mp="11bx8gf8xhcs7" />

      {/* Modal de Registro SEM código de convite */}
      <RegisterModalNoCode isOpen={isRegisterModalOpen} onClose={() => setIsRegisterModalOpen(false)} onLoginClick={handleOpenLogin} pendingAnalysis={pendingAnalysis} data-id="element-1377" data-mp="1ademzt6ot6es" />
    </>;
};
export default ShareDiegoIvoEventos;